// Generated by CoffeeScript 2.4.1
(function() {
  var ErrorCodes, Promise, Weaver, WeaverError, WeaverQuery, _, cuid, quote, util,
    indexOf = [].indexOf;

  _ = require('lodash');

  Promise = require('bluebird');

  cuid = require('cuid');

  util = require('./util');

  Weaver = require('./Weaver');

  WeaverError = require('./Error');

  ErrorCodes = require('./WeaverError');

  // Converts a string into a regex that matches it.
  // Surrounding with \Q .. \E does this, we just need to escape any \E's in
  // the text separately.
  quote = function(s) {
    return '\\Q' + s.replace('\\E', '\\E\\\\E\\Q') + '\\E';
  };

  WeaverQuery = (function() {
    var compareSortedNodeLists, resultsToNodes;

    class WeaverQuery {
      constructor(target1, branchId) {
        this.target = target1;
        this.branchId = branchId;
        this._cache = void 0;
        this._restrict = [];
        this._equals = {};
        this._orQueries = [];
        this._conditions = {};
        this._createdBy = void 0;
        this._include = [];
        this._select = void 0;
        this._selectRelations = void 0;
        this._selectOut = [];
        this._selectOutMinus = void 0;
        this._selectIn = void 0;
        this._peekIn = void 0;
        this._selectInMinus = void 0;
        this._selectInOnLoad = void 0;
        this._ignoreRelations = void 0;
        this._selectRecursiveOut = [];
        this._selectRecursiveIn = [];
        this._recursiveConditions = [];
        this._alwaysLoadAttributes = [];
        this._alwaysLoadRelations = [];
        this._noRelations = true;
        this._noAttributes = true;
        this._count = false;
        this._countPerGraph = false;
        this._hollow = false;
        this._limit = 99999;
        this._skip = 0;
        this._order = [];
        this._ascending = true;
        this._arrayCount = 0;
        this._inGraph = void 0;
        this._notInGraph = void 0;
        this._graphFilter = void 0;
        this._nextResults = false;
        this._keepOpen = false;
        this._resultSetId = void 0;
        this._autoClose = true;
        this._returnEmpty = false;
        this._hasNoLabel = void 0;
        this._hasLabel = void 0;
        this._excludeNodes = [];
        this._filterFunction = void 0;
        this._metaNodesQuery = void 0;
      }

      clone() {
        var newQuery;
        newQuery = new Weaver.Query();
        newQuery._cache = this._cache;
        newQuery._restrict = _.clone(this._restrict);
        newQuery._equals = _.cloneDeep(this._equals);
        newQuery._orQueries = _.clone(this._orQueries);
        newQuery._conditions = _.cloneDeep(this._conditions);
        newQuery._createdBy = this._createdBy;
        newQuery._include = _.clone(this._include);
        newQuery._select = this._select;
        newQuery._selectRelations = this._selectRelations;
        newQuery._selectOut = _.clone(this._selectOut);
        newQuery._selectOutMinus = this._selectOutMinus;
        newQuery._selectIn = this._selectIn;
        newQuery._peekIn = this._peekIn;
        newQuery._selectInMinus = this._selectInMinus;
        newQuery._selectInOnLoad = this._selectInOnLoad;
        newQuery._ignoreRelations = this._ignoreRelations;
        newQuery._selectRecursiveOut = _.clone(this._selectRecursiveOut);
        newQuery._selectRecursiveIn = _.clone(this._selectRecursiveIn);
        newQuery._recursiveConditions = _.clone(this._recursiveConditions);
        newQuery._alwaysLoadAttribute = _.clone(this._alwaysLoadAttributes);
        newQuery._alwaysLoadRelations = _.clone(this._alwaysLoadRelations);
        newQuery._noRelations = this._noRelations;
        newQuery._noAttributes = this._noAttributes;
        newQuery._count = this._count;
        newQuery._countPerGraph = this._countPerGraph;
        newQuery._hollow = this._hollow;
        newQuery._limit = this._limit;
        newQuery._skip = this._skip;
        newQuery._order = _.clone(this._order);
        newQuery._ascending = this._ascending;
        newQuery._arrayCount = this._arrayCount;
        newQuery._inGraph = this._inGraph;
        newQuery._notInGraph = this._notInGraph;
        newQuery._graphFilter = this._graphFilter;
        newQuery._nextResults = this._nextResults;
        newQuery._keepOpen = this._keepOpen;
        newQuery._resultSetId = this._resultSetId;
        newQuery._autoClose = this._autoClose;
        newQuery._returnEmpty = this._returnEmpty;
        newQuery._hasNoLabel = this._hasNoLabel;
        newQuery._hasLabel = this._hasLabel;
        newQuery._excludeNodes = _.clone(this._excludeNodes);
        newQuery._metaNodesQuery = this._metaNodesQuery;
        newQuery._filterFunction = this._filterFunction;
        return newQuery;
      }

      setLoggingTag(tag) {
        this._loggingTag = tag;
        return this;
      }

      setMetaNodesQuery(query) {
        this._metaNodesQuery = query;
        return this;
      }

      setFilterFunction(fun) {
        this._filterFunction = fun;
        return this;
      }

      // depredated, default behaviour is no longer dependent on an existing transaction
      outsideTransaction() {
        return this;
      }

      useTransaction(transaction) {
        this.transaction = transaction;
        this._autoClose = false;
        return this;
      }

      getNodeIdFromStringOrNode(node) {
        if (_.isString(node)) {
          return node;
        } else if (node instanceof Weaver.Node) {
          return {
            id: node.id(),
            graph: node.getGraph()
          };
        } else if (_.isObject(node) && (node.id != null)) {
          return node;
        } else {
          throw new Error(`Unsupported type: ${node}`);
        }
      }

      nodeRelationArrayValue(nodes) {
        var i, k, len, results;
        if (nodes.length > 0) {
          results = [];
          for (k = 0, len = nodes.length; k < len; k++) {
            i = nodes[k];
            results.push(this.getNodeIdFromStringOrNode(i));
          }
          return results;
        } else {
          return ["*"];
        }
      }

      stripQuery(query) {
        if (query.destruct != null) {
          return query.destruct();
        } else {
          return query;
        }
      }

      queryRelationArrayValue(queries) {
        var k, len, query, results;
        if (queries.length > 0) {
          results = [];
          for (k = 0, len = queries.length; k < len; k++) {
            query = queries[k];
            results.push(this.stripQuery(query));
          }
          return results;
        } else {
          return queries;
        }
      }

      async unlimited(chunkSize = 500, skip = 0, total = []) {
        var result;
        if (chunkSize > 1000) {
          chunkSize = 1000;
        }
        this._autoClose = false;
        this.limit(chunkSize);
        this.skip(skip);
        result = (await this.find(void 0, {
          statistics: true
        }));
        total = total.concat(result.list);
        if (result.unfilteredResultSize === chunkSize) {
          return this.unlimited(chunkSize, skip + chunkSize, total);
        } else {
          return total;
        }
      }

      useCache(_cache) {
        this._cache = _cache;
        return this;
      }

      next() {
        this._nextResults = true;
        return this.find();
      }

      async _getTransaction() {
        var cm, ref;
        if ((this.transaction == null) && !this._keepOpen) {
          return;
        }
        cm = Weaver.getCoreManager();
        if (this.transaction == null) {
          if (this._keepOpen) {
            this._autoClose = true;
          }
          return this.transaction = (await Weaver.getInstance().startTransaction({
            branch: this.branchId || ((ref = cm.currentBranch) != null ? ref.id() : void 0) || cm.defaultBranch,
            project: this.target
          }));
        } else {
          return this.transaction;
        }
      }

      async find(Constructor, opts = {}) {
        var castedNode, clone, dirtyCxt, exclude, k, l, len, len1, list, object, ref, ref1, result, signature, signatures, unfilteredResultSize;
        if (Constructor != null) {
          this.setConstructorFunction(function() {
            return Constructor;
          });
        }
        dirtyCxt = false;
        if (Weaver.Query.getHiddenGraphs().length > 0) {
          if (!((this._notInGraph != null) || (this._inGraph != null))) {
            dirtyCxt = true;
            this.notInGraph(...Weaver.Query.getHiddenGraphs());
          }
        }
        list = new Weaver.NodeList();
        await this._getTransaction(); // will only start transaction if needed
        clone = this.preSerialize();
        if (this.transaction != null) {
          clone._transaction = this.transaction.id();
          clone.target = this.transaction.getProject();
        }
        result = (await Weaver.getCoreManager().query(clone));
        exclude = {};
        await Promise.map(this._excludeNodes, async function(set) {
          var k, len, name, node, ref, results;
          ref = ((await new Weaver.Sparql(`SELECT ?node WHERE { ?node <${set.key}> <${set.target}> }`).find())).node;
          results = [];
          for (k = 0, len = ref.length; k < len; k++) {
            node = ref[k];
            if (exclude[name = node.getGraph()] == null) {
              exclude[name] = {};
            }
            results.push(exclude[node.getGraph()][node.id()] = true);
          }
          return results;
        });
        Weaver.Query.notify(result);
        unfilteredResultSize = 0;
        // a new way to keep data
        if (this._cache != null) {
          signatures = this.resultToCache(result);
          for (k = 0, len = signatures.length; k < len; k++) {
            signature = signatures[k];
            list.push(this._cache.evokeNode(signature));
          }
        } else {
          ref = result.nodes;
          // deprecate this in the future
          for (l = 0, len1 = ref.length; l < len1; l++) {
            object = ref[l];
            if ((this._filterFunction == null) || this._filterFunction(object, this)) {
              castedNode = Weaver.Node.loadFromQuery(object, this.constructorFunction, (this._selectRelations == null) && (this._select == null), this.model, exclude, this._filterFunction);
              unfilteredResultSize++;
              if ((ref1 = exclude[castedNode.getGraph()]) != null ? ref1[castedNode.id()] : void 0) {
                continue;
              }
              list.push(castedNode);
            }
          }
        }
        if ((this.transaction != null) && this._autoClose && !this._keepOpen) {
          await this.transaction.commit();
          this.transaction = void 0;
        }
        if (dirtyCxt) {
          this._notInGraph = void 0;
        }
        if (this._metaNodesQuery != null) {
          list = (await this.loadMetaNodes(list));
        }
        if (opts.statistics) {
          return {list, unfilteredResultSize};
        } else {
          return list;
        }
      }

      async loadMetaNodes(result, loaded = []) {
        var id, k, l, len, len1, len2, loadedNodes, m, metaNode, metaNodes, n, newToLoad, node, query, record, ref, visited;
        // build map of what needs to be loaded
        metaNodes = {}; // map id -> record meta-node owner (WeaverAttribute or WeaverRelation)
        visited = [];
        for (k = 0, len = result.length; k < len; k++) {
          node = result[k];
          node._traverseNode(function(node, record) {
            var existingRecord;
            if (record == null) {
              return;
            }
            existingRecord = metaNodes[node.id()];
            if (existingRecord && !existingRecord.equals(record)) {
              throw Error(`Already got ${node.id() // assume one metaNode maps to one record
}`);
            }
            return metaNodes[node.id()] = record;
          }, visited);
        }
        // perform the loading
        loadedNodes = {};
        newToLoad = (function() {
          var results;
          results = [];
          for (id in metaNodes) {
            n = metaNodes[id];
            if (indexOf.call(loaded, id) < 0) {
              results.push(id);
            }
          }
          return results;
        })();
        query = this._metaNodesQuery.clone();
        ref = (await query.restrict(newToLoad).withAttributes().withRelations().unlimited());
        for (l = 0, len1 = ref.length; l < len1; l++) {
          node = ref[l];
          loadedNodes[node.id()] = node;
        }
        loaded = [...loaded, ...newToLoad];
// replace the non-loaded nodes with the loaded equivalents
        for (m = 0, len2 = newToLoad.length; m < len2; m++) {
          id = newToLoad[m];
          record = metaNodes[id];
          metaNode = loadedNodes[id];
          if (metaNode == null) {
            throw new Error(`Was not able to load ${id}`);
          }
          if (metaNode instanceof Weaver.RelationNode) {
            record.relNode = metaNode;
            metaNode.fromNode = record.fromNode;
            metaNode.toNode = record.toNode;
          }
          if (metaNode instanceof Weaver.AttributeNode) {
            record.attNode = metaNode;
            metaNode.fromNode = record.fromNode;
          }
        }
        if (newToLoad.length > 0) {
          return (await this.loadMetaNodes(result, loaded));
        } else {
          return result;
        }
      }

      resultToCache(result) {
        var addItem, firstOrderSignatures, item, k, len, ref, signature;
        firstOrderSignatures = [];
        addItem = function(cache, item) {
          var a, attributes, k, key, l, len, len1, len2, m, map, r, ref, ref1, ref2, relations;
          map = cache.addNode(item.nodeId, item.graph, item.creator, item.created);
          ref = item.attributes;
          for (key in ref) {
            attributes = ref[key];
            for (k = 0, len = attributes.length; k < len; k++) {
              a = attributes[k];
              addItem(cache, a);
              cache.addAttribute(item.nodeId, item.graph, a.key, a.value, a.dataType, a.nodeId, a.graph);
            }
          }
          ref1 = item.relations;
          for (key in ref1) {
            relations = ref1[key];
            for (l = 0, len1 = relations.length; l < len1; l++) {
              r = relations[l];
              addItem(cache, r);
              addItem(cache, r.target);
              cache.addRelation(item.nodeId, item.graph, r.key, r.target.nodeId, r.target.graph, r.nodeId, r.graph);
            }
          }
          ref2 = item.relationsIn;
          for (key in ref2) {
            relations = ref2[key];
            for (m = 0, len2 = relations.length; m < len2; m++) {
              r = relations[m];
              addItem(cache, r);
              addItem(cache, r.source);
              cache.addRelation(r.source.nodeId, r.source.graph, r.key, item.nodeId, item.graph, r.nodeId, r.graph);
            }
          }
          return map.signature;
        };
        this._cache._lastUpdate = new Date().getTime();
        this._cache.startSuppress();
        ref = result.nodes;
        for (k = 0, len = ref.length; k < len; k++) {
          item = ref[k];
          signature = addItem(this._cache, item);
          firstOrderSignatures.push(signature);
        }
        this._cache.releaseSuppress();
        return firstOrderSignatures;
      }

      async close() {
        if (this.transaction == null) {
          return;
        }
        if (this._keepOpen) {
          await Weaver.getCoreManager().releaseResultSet(this.transaction, this._resultSetId);
        }
        if (this._autoClose) {
          await this.transaction.commit();
          return this.transaction = void 0;
        }
      }

      async count() {
        var result;
        this._count = true;
        try {
          result = (await Weaver.getCoreManager().query(this.preSerialize()));
          Weaver.Query.notify(result);
          return result.count;
        } catch (error) {

        } finally {
          // empty
          this._count = false;
        }
      }

      async countPerGraph() {
        var result;
        this._countPerGraph = true;
        try {
          result = (await Weaver.getCoreManager().query(this.preSerialize()));
          Weaver.Query.notify(result);
          return result;
        } catch (error) {

        } finally {
          // empty
          this._countPerGraph = false;
        }
      }

      async first(Constructor, opts) {
        var res;
        this._limit = 1;
        res = (await this.find(Constructor, opts));
        if (res.length === 0) {
          // todo: when throwing this object the browser reports:
          // Warning: a promise was rejected with a non-error: [object Object]
          throw WeaverError(ErrorCodes.NODE_NOT_FOUND, `Node ${JSON.stringify(this._restrict)} not found in ${JSON.stringify(this._inGraph)}`);
        } else {
          return res[0];
        }
      }

      get(node, params = {}) {
        this.restrict(node);
        this.restrictGraphs(params.graph);
        return this.first(params.NodeClass);
      }

      restrict(nodes) {
        var k, len, node;
        if (util.isArray(nodes)) {
          this._restrict = []; // Clear
          for (k = 0, len = nodes.length; k < len; k++) {
            node = nodes[k];
            if (node != null) {
              this._restrict.push(this.getNodeIdFromStringOrNode(node));
            }
          }
        } else {
          this._restrict.push(this.getNodeIdFromStringOrNode(nodes));
        }
        if (this._restrict.length === 0) {
          this._returnEmpty = true;
        }
        return this;
      }

      _addRestrictGraph(graph) {
        if (this._inGraph == null) {
          this._inGraph = [];
        }
        return this._inGraph.push(graph);
      }

      inGraph(...graphs) {
        var i, k, len;
        for (k = 0, len = graphs.length; k < len; k++) {
          i = graphs[k];
          this._addRestrictGraph(i);
        }
        return this;
      }

      _addNotInGraph(graph) {
        if (this._notInGraph == null) {
          this._notInGraph = [];
        }
        return this._notInGraph.push(graph);
      }

      notInGraph(...graphs) {
        var i, k, len;
        for (k = 0, len = graphs.length; k < len; k++) {
          i = graphs[k];
          this._addNotInGraph(i);
        }
        return this;
      }

      restrictGraphs(graphs) {
        var graph, k, len;
        this._inGraph = []; // Clear
        if (util.isArray(graphs)) {
          for (k = 0, len = graphs.length; k < len; k++) {
            graph = graphs[k];
            this._addRestrictGraph(graph);
          }
        } else {
          this._addRestrictGraph(graphs);
        }
        return this;
      }

      graphFilter(graphs) {
        var graph, k, len;
        this._graphFilter = []; // Clear
        if (util.isArray(graphs)) {
          for (k = 0, len = graphs.length; k < len; k++) {
            graph = graphs[k];
            this._addGraphFilter(graph);
          }
        } else {
          this._addGraphFilter(graphs);
        }
        return this;
      }

      _addGraphFilter(graph) {
        if (this._graphFilter == null) {
          this._graphFilter = [];
        }
        return this._graphFilter.push(graph);
      }

      _addAttributeCondition(key, condition, value, emptyAllowed = false) {
        if ((value != null) && (emptyAllowed || value !== '')) {
          return this._addCondition(key, condition, value);
        } else {
          return this;
        }
      }

      _addRelationCondition(key, condition, value) {
        return this._addCondition(key, condition, value);
      }

      _addCondition(key, condition, value) {
        delete this._equals[key];
        this._conditions[key] = this._conditions[key] || {};
        this._conditions[key][condition] = value;
        return this;
      }

      equalTo(key, value) {
        delete this._conditions[key];
        this._equals[key] = value;
        return this;
      }

      isLike(key, value) {
        return this._addAttributeCondition(key, '$lk', value, true);
      }

      equalToNew(key, value) {
        return this._addAttributeCondition(key, '$eq', value, true);
      }

      equalToIgnoreCase(key, value) {
        return this._addAttributeCondition(key, '$eqic', value, true);
      }

      notEqualTo(key, value) {
        return this._addAttributeCondition(key, '$ne', value, true);
      }

      lessThan(key, value) {
        return this._addAttributeCondition(key, '$lt', value);
      }

      greaterThan(key, value) {
        return this._addAttributeCondition(key, '$gt', value);
      }

      lessThanOrEqualTo(key, value) {
        return this._addAttributeCondition(key, '$lte', value);
      }

      greaterThanOrEqualTo(key, value) {
        return this._addAttributeCondition(key, '$gte', value);
      }

      hasRelationIn(key, ...node) {
        if (_.isArray(key)) {
          return this._addRelationCondition("$relationArray${@arrayCount++}", '$relIn', key);
        } else if (node.length === 1 && node[0] instanceof WeaverQuery) {
          return this._addRelationCondition(key, '$relIn', this.queryRelationArrayValue(node));
        } else {
          return this._addRelationCondition(key, '$relIn', this.nodeRelationArrayValue(node));
        }
      }

      hasRelationOut(key, ...node) {
        if (_.isArray(key)) {
          this._addRelationCondition("$relationArray${@arrayCount++}", '$relOut', key);
        } else if (node.length === 1 && node[0] instanceof WeaverQuery) {
          this._addRelationCondition(key, '$relOut', this.queryRelationArrayValue(node));
        } else {
          this._addRelationCondition(key, '$relOut', this.nodeRelationArrayValue(node));
        }
        return this;
      }

      hasNoRelationIn(key, ...node) {
        if (_.isArray(key)) {
          return this._addRelationCondition("$relationArray${@arrayCount++}", '$noRelIn', key);
        } else if (node.length === 1 && node[0] instanceof WeaverQuery) {
          return this._addRelationCondition(key, '$noRelIn', this.queryRelationArrayValue(node));
        } else {
          return this._addRelationCondition(key, '$noRelIn', this.nodeRelationArrayValue(node));
        }
      }

      hasNoRelationOut(key, ...node) {
        if (_.isArray(key)) {
          return this._addRelationCondition("$relationArray${@arrayCount++}", '$noRelOut', key);
        } else if (node.length === 1 && node[0] instanceof WeaverQuery) {
          return this._addRelationCondition(key, '$noRelOut', this.queryRelationArrayValue(node));
        } else {
          if (node.destruct != null) {
            node = node.destruct();
          }
          return this._addRelationCondition(key, '$noRelOut', this.nodeRelationArrayValue(node));
        }
      }

      _addRecursiveCondition(op, relation, node, includeSelf) {
        var graph, nodeId;
        nodeId = '';
        graph = void 0;
        if (node instanceof Weaver.Query) {
          throw new Error('Not allowed to give sub query to recursive condition');
        } else if (node instanceof Weaver.Node) {
          nodeId = node.id();
          graph = node.getGraph();
        } else {
          nodeId = node;
        }
        this._recursiveConditions.push({
          operation: op,
          relation,
          nodeId,
          nodeGraph: graph,
          includeSelf
        });
        return this;
      }

      hasNoRecursiveRelationIn(key, node, includeSelf = false) {
        return this._addRecursiveCondition('$noRelIn', key, node, includeSelf);
      }

      hasNoRecursiveRelationOut(key, node, includeSelf = false) {
        return this._addRecursiveCondition('$noRelOut', key, node, includeSelf);
      }

      hasRecursiveRelationIn(key, node, includeSelf = false) {
        return this._addRecursiveCondition('$relIn', key, node, includeSelf);
      }

      hasRecursiveRelationOut(key, node, includeSelf = false) {
        return this._addRecursiveCondition('$relOut', key, node, includeSelf);
      }

      containedIn(key, values) {
        return this._addAttributeCondition(key, '$in', values);
      }

      notContainedIn(key, values) {
        return this._addAttributeCondition(key, '$nin', values);
      }

      containsAll(key, values) {
        return this._addAttributeCondition(key, '$all', values);
      }

      exists(key) {
        return this._addAttributeCondition(key, '$exists', true);
      }

      doesNotExist(key) {
        return this._addAttributeCondition(key, '$exists', false);
      }

      matches(key, value) {
        return this._addAttributeCondition(key, '$regex', value);
      }

      contains(key, value) {
        return this._addAttributeCondition(key, '$contains', value);
      }

      startsWith(key, value) {
        return this._addAttributeCondition(key, '$regex', '^' + value);
      }

      endsWith(key, value) {
        return this._addAttributeCondition(key, '$regex', value + '$');
      }

      withAttributes() {
        this._noAttributes = false;
        return this;
      }

      withRelations() {
        this._noRelations = false;
        return this;
      }

      noRelations() {
        this._noRelations = true;
        return this;
      }

      noAttributes() {
        this._noAttributes = true;
        return this;
      }

      order(keys, ascending) {
        this._order = keys;
        this._ascending = ascending;
        return this;
      }

      ascending(keys) {
        return this.order(keys, true);
      }

      descending(keys) {
        return this.order(keys, false);
      }

      skip(skip) {
        if (typeof skip !== 'number' || skip < 0) {
          throw new Error('Invalid argument: skip should be a positive number');
        }
        this._skip = skip;
        return this;
      }

      limit(limit) {
        if (typeof limit !== 'number' || limit < 0) {
          throw new Error('Invalid argument: limit should be a positive number');
        }
        this._limit = limit;
        return this;
      }

      limitRelations(limit) {
        if (typeof limit !== 'number' || limit < 0) {
          throw new Error('Invalid argument: limit should be a positive number');
        }
        this._limitRelations = limit;
        return this;
      }

      batchSize(batchSize) {
        this._batchSize = batchSize;
        return this;
      }

      keepOpen(keepOpen = true) {
        this._keepOpen = keepOpen;
        if (keepOpen) {
          if (this._resultSetId == null) {
            this._resultSetId = cuid();
          }
        } else {
          this._resultSetId = void 0;
        }
        return this;
      }

      include(keys) {
        this._include = keys;
        return this;
      }

      selectRelations(...keys) {
        this._selectRelations = keys;
        return this;
      }

      select(...keys) {
        this._select = keys;
        return this;
      }

      selectOut(...relationKeys) {
        this._selectOut.push(relationKeys);
        return this;
      }

      selectOutMinus(...relationKeys) {
        var k, key, len;
        if (this._selectOutMinus == null) {
          this._selectOutMinus = [];
        }
        for (k = 0, len = relationKeys.length; k < len; k++) {
          key = relationKeys[k];
          this._selectOutMinus.push(key);
        }
        return this;
      }

      selectIn(...relationKeys) {
        if (this._selectIn == null) {
          this._selectIn = [];
        }
        this._selectIn.push(relationKeys);
        return this;
      }

      peekIn() {
        this._peekIn = true;
        return this;
      }

      selectInMinus(...relationKeys) {
        var k, key, len;
        if (this._selectInMinus == null) {
          this._selectInMinus = [];
        }
        for (k = 0, len = relationKeys.length; k < len; k++) {
          key = relationKeys[k];
          this._selectInMinus.push(key);
        }
        return this;
      }

      selectInOnLoad() {
        this._selectInOnLoad = true;
        return this;
      }

      ignoreRelations(...keys) {
        var k, key, len;
        if (this._ignoreRelations == null) {
          this._ignoreRelations = [];
        }
        for (k = 0, len = keys.length; k < len; k++) {
          key = keys[k];
          this._ignoreRelations.push(key);
        }
        return this;
      }

      hasNoLabel(...labels) {
        var k, label, len;
        if (this._hasNoLabel == null) {
          this._hasNoLabel = [];
        }
        for (k = 0, len = labels.length; k < len; k++) {
          label = labels[k];
          this._hasNoLabel.push(label);
        }
        return this;
      }

      hasLabel(...labels) {
        var k, label, len;
        if (this._hasLabel == null) {
          this._hasLabel = [];
        }
        for (k = 0, len = labels.length; k < len; k++) {
          label = labels[k];
          this._hasLabel.push(label);
        }
        return this;
      }

      createdBy(user) {
        this._createdBy = user.id();
        return this;
      }

      selectRecursiveOut(...relationKeys) {
        this._selectRecursiveOut = relationKeys;
        return this;
      }

      selectRecursiveIn(...relationKeys) {
        this._selectRecursiveIn = relationKeys;
        return this;
      }

      alwaysLoadAttributes(...attributeKeys) {
        var i, k, key, l, len, len1;
        for (k = 0, len = attributeKeys.length; k < len; k++) {
          i = attributeKeys[k];
          if (_.isArray(i)) {
            for (l = 0, len1 = i.length; l < len1; l++) {
              key = i[l];
              this._alwaysLoadAttributes.push(key);
            }
          } else {
            this._alwaysLoadAttributes.push(i);
          }
        }
        return this;
      }

      alwaysLoadRelations(...relationKeys) {
        var i, k, key, l, len, len1;
        for (k = 0, len = relationKeys.length; k < len; k++) {
          i = relationKeys[k];
          if (_.isArray(i)) {
            for (l = 0, len1 = i.length; l < len1; l++) {
              key = i[l];
              this._alwaysLoadRelations.push(key);
            }
          } else {
            this._alwaysLoadRelations.push(i);
          }
        }
        return this;
      }

      hollow(value) {
        this._hollow = value;
        return this;
      }

      or(queries) {
        this._orQueries = queries;
        return this;
      }

      static or(queries) {
        var query;
        query = new Weaver.Query();
        query.or(queries);
        return query;
      }

      static profile(callback) {
        return Weaver.Query.profilers.push(callback);
      }

      static clearProfilers() {
        return Weaver.Query.profilers = [];
      }

      static notify(result) {
        var callback, k, len, ref, results;
        ref = Weaver.Query.profilers;
        results = [];
        for (k = 0, len = ref.length; k < len; k++) {
          callback = ref[k];
          results.push(callback(result));
        }
        return results;
      }

      setConstructorFunction(constructorFunction) {
        this.constructorFunction = constructorFunction;
        return this;
      }

      nativeQuery(query) {
        return Weaver.getCoreManager().nativeQuery(query, Weaver.getInstance().currentProject().id());
      }

      destruct() {
        delete this.target;
        delete this.constructorFunction;
        return this;
      }

      preSerialize() {
        return _.omit(this, ['model', 'context', '_cache', 'preferredConstructor', 'constructorFunction', '_excludeNodes', '_filterFunction', '_metaNodesQuery']);
      }

      static setHiddenGraphs(hidden) {
        return this.hiddenGraphs = hidden;
      }

      static getHiddenGraphs() {
        return this.hiddenGraphs;
      }

      excludeNodesWith(key, target) {
        this._excludeNodes.push({key, target});
        return this;
      }

      excludeAttributesWith(key, target) {
        this._excludeNodes.push({key, target});
        return this;
      }

      excludeRelationsWith(key, target) {
        this._excludeNodes.push({key, target});
        return this;
      }

    };

    WeaverQuery.profilers = [];

    WeaverQuery.hiddenGraphs = [];

    resultsToNodes = function(nodes) {
      var graph, id, k, len, n, newList, node;
      newList = [];
      for (k = 0, len = nodes.length; k < len; k++) {
        n = nodes[k];
        id = Object.keys(n)[0];
        graph = n[id];
        if (graph === 'undefined') {
          graph = void 0;
        }
        node = new Weaver.Node(id, graph);
        newList.push(node);
      }
      return newList;
    };

    compareSortedNodeLists = (nodes, compare) => {
      var graphMap, i, j, k, len, node;
      graphMap = {};
//First set all nodes to false, follow loops will only check for true values
      for (k = 0, len = nodes.length; k < len; k++) {
        node = nodes[k];
        if (graphMap[node.getGraph()] == null) {
          graphMap[node.getGraph()] = {};
        }
        graphMap[node.getGraph()][node.id()] = false;
      }
      // Algorithm to find all existing nodes, twice as fast as nested for loop on 10000 nodes.
      i = 0;
      j = 0;
      while (i < nodes.length && j < compare.length) {
        if (nodes[i].id() === compare[j].id() && nodes[i].getGraph() === compare[j].getGraph()) {
          graphMap[nodes[i].getGraph()][nodes[i].id()] = true;
          i++;
          j++;
        } else if (nodes[i].id() < compare[j].id()) {
          i++;
        } else {
          j++;
        }
      }
      return graphMap;
    };

    return WeaverQuery;

  }).call(this);

  // Export
  module.exports = WeaverQuery;

}).call(this);
